import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

interface Props {
  value?: boolean | any[];
  checkboxValue?: number | null;
  disabled?: boolean;
}
interface Emits {
  (e: 'input', data: Props['value']): void;
  (e: 'change', data: Props['value']): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiCheckbox',
  props: {
    value: { type: [Boolean, Array], default: false },
    checkboxValue: { default: null },
    disabled: { type: Boolean, default: false }
  },
  emits: ["input", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', data: Props['value']): void;
  (e: 'change', data: Props['value']): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean | any[], checkboxValue: number | null, disabled: boolean };





const valueLocal = computed({
  get() {
    return props.value;
  },
  set(newValue) {
    if (props.disabled) return;
    // eslint-disable-next-line vue/require-explicit-emits
    emit('input', newValue);
    // eslint-disable-next-line vue/require-explicit-emits
    emit('change', newValue);
  },
});

return { __sfc: true,props, emit, valueLocal }
}

})